const VerbatimFilter = (verbatims, filters) => {
  const { source, dynamicFilters } = filters || {};

  // Ensure verbatims is an array before proceeding
  if (!Array.isArray(verbatims)) {
    return []; // Return an empty array if verbatims is not a valid array
  }

  // Ensure dynamicFilters is an object before proceeding
  if (!dynamicFilters || typeof dynamicFilters !== 'object') {
    return verbatims; // Return original verbatims if dynamicFilters is invalid or missing
  }

  return verbatims.filter((verbatim) => {
    // First, handle the source filter (if applied)
    if (source && (!verbatim.source || !verbatim.source.includes(source))) {
      return false; // Skip this verbatim if source doesn't match
    }
  
    // Ensure verbatim.labels exists before proceeding with dynamicFilters
    if (!verbatim.labels || typeof verbatim.labels !== 'object') return false;
  
    // Iterate over dynamicFilters to check each label type
    return Object.keys(dynamicFilters).every((labelType) => {
      const selectedLabels = dynamicFilters[labelType];
  
      // If no filter is applied for a label type, don't filter by it
      if (!selectedLabels || selectedLabels.length === 0) return true;
  
      // Ensure that verbatim.labels[labelType] exists and is an array
      const verbatimLabels = verbatim.labels?.[labelType];
  
      // Handle "NO_LABELS" filter with OR condition
      const hasNoLabels =
        selectedLabels.includes('NO_LABELS') &&
        (!Array.isArray(verbatimLabels) || verbatimLabels.length === 0);
  
      const hasMatchingLabels =
        Array.isArray(verbatimLabels) &&
        selectedLabels.some((labelName) =>
          verbatimLabels.some((verbatimLabel) =>
            verbatimLabel?.name === labelName // Ensure verbatimLabel exists and has a name property
          )
        );
  
      // Return true if either condition matches
      return hasNoLabels || hasMatchingLabels;
    });
  });  
};

export default VerbatimFilter;
